import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as packageActions from '../actions';
import { produceOn } from '../../../../reducers/immer.helper';

export interface PackageDetailState {
  currentPackageDetail?: any;
  isLoading?: boolean;
  actionInProgress?: boolean;
  actionSuccessful?: boolean;
}


export const initialState: PackageDetailState = {
  currentPackageDetail: {},
  isLoading: false,
  actionInProgress: false,
  actionSuccessful: true,
};

const PackageDetailReducer = createReducer(
  initialState,
  produceOn(packageActions.getPackageDetailById, (draft, result) => {
    draft.isLoading = true;
  }),
  produceOn(packageActions.getPackageDetailByIdSuccess, (draft, result) => {
    draft.currentPackageDetail = result.data;
    draft.isLoading = false;
  }),
  produceOn(packageActions.getPackageDetailByIdFailure, (draft, result) => {
    draft.isLoading = false;
  }),
  produceOn(packageActions.getPackageDetailBySlug, (draft, result) => {
    draft.isLoading = true;
  }),
  produceOn(packageActions.getPackageDetailBySlugSuccess, (draft, result) => {
    draft.currentPackageDetail = result.data;
    draft.isLoading = false;
  }),
  produceOn(packageActions.getPackageDetailBySlugFailure, (draft, result) => {
    draft.isLoading = false;
  }),

  // this is for getDealDetails
  produceOn(packageActions.getDealDetails, (draft, result) => {
    draft.isLoading = true;
  }),
  produceOn(packageActions.getDealDetailsSuccess, (draft, result) => {
    draft.currentPackageDetail = result.data;
    draft.isLoading = false;
  }),
  produceOn(packageActions.getDealDetailsFailure, (draft, result) => {
    draft.isLoading = false;
  })
);

export function reducer(
  state: PackageDetailState | undefined,
  action: Action
): any {
  return PackageDetailReducer(state, action);
}
